import { render, staticRenderFns } from "./CustomPermissionView.vue?vue&type=template&id=018a1618"
import script from "./CustomPermissionView.vue?vue&type=script&lang=js"
export * from "./CustomPermissionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports